import React, { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";

const Sidebar: React.FC = () => {
  const routes = all_routes;
  const location = useLocation();
  const [openBookings, setOpenBookings] = useState(true); // default open

  // Read user from session (no hardcode)
  const { userName, sinceText } = useMemo(() => {
    try {
      const userJson = sessionStorage.getItem("user");
      const u = userJson ? JSON.parse(userJson) : null;
      const name =
        u?.name ||
        u?.displayName ||
        u?.email?.split("@")[0] ||
        sessionStorage.getItem("user_name") ||
        "User";
      const created = u?.created_at || u?.createdAt || "";
      const since = created ? `Since ${created}` : "";
      return { userName: name, sinceText: since };
    } catch {
      return { userName: "User", sinceText: "" };
    }
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="card user-sidebar mb-4 mb-lg-0 theiaStickySidebar">
      <div className="card-header user-sidebar-header">
        <div className="profile-content rounded-pill">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <ImageWithBasePath
                src="assets/img/users/user-01.jpg"
                alt="image"
                className="img-fluid avatar avatar-lg rounded-circle flex-shrink-0 me-2"
              />
              <div>
                <h6 className="fs-16 mb-0">{userName}</h6>
                {sinceText ? <span className="fs-14 text-gray-6">{sinceText}</span> : null}
              </div>
            </div>
            <Link
              to={routes.profileSettings}
              className="p-1 rounded-circle btn btn-light d-flex align-items-center justify-content-center"
              title="Settings"
            >
              <i className="isax isax-edit-2 fs-14" />
            </Link>
          </div>
        </div>
      </div>

      <div className="card-body user-sidebar-body">
        <ul>
          {/* My Bookings (Flights + Hotels) */}
          <li className="submenu">
            <button
              type="button"
              onClick={() => setOpenBookings((s) => !s)}
              className={`d-block w-100 text-start ${openBookings ? "subdrop" : ""} ${
                location.pathname.includes("customer") ? "active" : ""
              }`}
              style={{ background: "transparent", border: 0, padding: 0 }}
            >
              <i className="isax isax-calendar-tick5" /> <span>My Bookings</span>
              <span className="menu-arrow" />
            </button>
            <ul className={`${openBookings ? "d-block" : ""}`}>
              <li>
                <Link
                  to={routes.userFlightBooking}
                  className={`fs-14 d-inline-flex align-items-center ${
                    location.pathname.includes("customer-flight-booking") ? "active" : ""
                  }`}
                >
                  Flights
                </Link>
              </li>
              <li>
                <Link
                  to={routes.userHotlesBooking}
                  className={`fs-14 d-inline-flex align-items-center ${
                    location.pathname.includes("customer-hotel-booking") ? "active" : ""
                  }`}
                >
                  Hotels
                </Link>
              </li>
            </ul>
          </li>

          {/* Payments */}
          <li className="mb-2">
            <Link
              to={routes.payment}
              className={`d-flex align-items-center ${location.pathname.includes("payment") ? "active" : ""}`}
            >
              <i className="isax isax-money-recive5" /> Payments
            </Link>
          </li>

          {/* Settings */}
          <li>
            <Link
              to={routes.profileSettings}
              className={`d-flex align-items-center ${location.pathname.includes("settings") ? "active" : ""}`}
            >
              <i className="isax isax-setting-25" /> Settings
            </Link>
          </li>

          {/* Logout (navigate to home; your header/auth should clear session) */}
          <li>
            <Link to={routes.home1} className="d-flex align-items-center pb-0">
              <i className="isax isax-logout-15" /> Logout
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
